/**
 * Created by Evgenii Kozhanov on 10.11.14.
 * Contributors: Mikhail Fedosov (tbs.micle@gmail.com)
 */
(function()
{   // "   x  " -> "x"
    function trim(s)
    {
        return s ? s.replace(/^\s+/, "").replace(/\s\s*$/, "") : s;
    }

    var getElementByClass = function(className)
    {
        if (document.getElementsByClassName) {
            return document.getElementsByClassName(className);
        } else {
            // IE8
            return document.querySelectorAll("." + className);
        }
    };

    function injectCSS(path, theme_name)
    {
        var bpp_default_style = document.createElement("link");
        bpp_default_style.setAttribute("rel", "stylesheet");
        bpp_default_style.setAttribute("async", "true");
        bpp_default_style.setAttribute("id", "__biletix__wl__css_"+theme_name+"");
        bpp_default_style.setAttribute("type", "text/css");
        bpp_default_style.setAttribute("href", path);
        document.head.insertBefore(bpp_default_style, document.head.firstChild);
    }

    var currencies =
    {
        "USD":
        {
            "currencyCode": "USD",
            "currencySymbol": "$"
        },
        "EUR":
        {
            "currencyCode": "EUR",
            "currencySymbol": "€"
        },
        "KZT":
        {
            "currencyCode": "KZT",
            "currencySymbol": "₸"
        },
        "BYN":
        {
            "currencyCode": "BYN",
            "currencySymbol": "Br"
        },
        "AMD": {
            "currencyCode": "AMD",
            "currencySymbol": "դր"
        }        
    };

    window.__biletix_graph__ =
    {

        showGraph : function () {

            var currentScript = document.getElementById("biletix_widget_graph");


            var biletixApiHost = "";
            try
            {
                if (currentScript)
                {
                    // !!! `head_js_path` используется после постобработки, удалять не нужно
                    var head_js_path = currentScript.getAttribute("src").split("?")[0].split("/").slice(0, -1).join("/") + "/"; // jshint ignore:line
                    biletixApiHost = currentScript.getAttribute("src").split("?")[0].replace("http://", "").replace("https://", "").split("/")[0];

                    var theme_name = currentScript.getAttribute("data-theme") || "default";


                    if (currentScript.getAttribute("data-disable-css") != "true") {
                        injectCSS(head_js_path + "biletix_widget.theme.graph.min.css", "graph");
                    }
                }
            }
            catch(e) { }

            if (biletixApiHost)
            {
                biletixApiHost = "https://" + biletixApiHost;
            }


            var div_elements = getElementByClass("biletix_widget_container__graph");



            for (var j = 0; j < div_elements.length; j++) {
                elem = div_elements[j];
                var data = { "from": decodeURI(elem.getAttribute("data-from")), "to": decodeURI(elem.getAttribute("data-to")) };
                elem.innerHTML = "<div class='biletix_widget_container__loading'>Строим график лучших цен...";
            }

            for (var i = 0; i < div_elements.length; i++) {
                elem = div_elements[i];

                if (elem.getAttribute("id") == null) {
                    elem.setAttribute("id", "biletix_widget_container__graph_" + i);
                }
            }



            var currentCurrency = null;
            for (var k = 0; k < div_elements.length; k++)
            {
                elem = div_elements[k];
                elem.classList.add("biletix_widget_container__best__not_sure");
                currentCurrency = elem.hasAttribute("data-currency") && currencies.hasOwnProperty(elem.getAttribute("data-currency")) ? 
                        currencies[elem.getAttribute("data-currency")]["currencyCode"] : null;

                function httpGetAsync(theUrl, callback) {
                    var xmlHttp = new XMLHttpRequest();
                    xmlHttp.onreadystatechange = function() {
                        if (xmlHttp.readyState == 4 && xmlHttp.status == 200)
                            callback(xmlHttp.responseText);
                    }
                    xmlHttp.open("GET", theUrl, true); // true for asynchronous 
                    xmlHttp.send(null);
                }
                httpGetAsync(biletixApiHost +
                    "/api/get_best_price_bar_chart/?data-from=" + encodeURI(elem.getAttribute("data-from"))
                    + "&data-to=" + encodeURI(elem.getAttribute("data-to"))
                    + "&group_by=Month"
                    + "&owrt=RT"
                    + "&data-channel=test_channel"
                    + "&fromCache=true"
                    + (currentCurrency ? "&currentCurrency=" + currentCurrency : "")
                    + (elem.hasAttribute("data-alt-domain") ? "&altDomain=" + elem.getAttribute("data-alt-domain") : "")
                    + "&callback=__biletix_graph__.drawGraph",
                    function(data) {
                        eval(data);
                        // console.log(data);
                    });

                // var jsonp_script = document.createElement("script");
                // jsonp_script.setAttribute("async", "async");
                // jsonp_script.setAttribute("defer", "defer");
                // jsonp_script.setAttribute("src", biletixApiHost
                //     + "/api/get_best_price_bar_chart/?data-from=" + encodeURI(elem.getAttribute("data-from"))
                //     + "&data-to=" + encodeURI(elem.getAttribute("data-to"))
                //     + "&group_by=Month"
                //     + "&owrt=RT"
                //     + "&data-channel=test_channel"
                //     + "&fromCache=true"
                //     + (currentCurrency ? "&currentCurrency=" + currentCurrency : "")
                //     + (elem.hasAttribute("data-alt-domain") ? "&altDomain=" + elem.getAttribute("data-alt-domain") : "")
                //     + "&callback=__biletix_graph__.drawGraph"
                //     );
                // document.body.appendChild(jsonp_script);
            }

        },

        drawGraph: function(data) {
            var prices = new Array();
            for (var j in data['bar_chart']){
                prices.push(data['bar_chart'][j]['price']);
            }

            var maxPrice = Math.max.apply(Math, prices);


            var minPrice = Math.min.apply(Math, prices);
            var percent = maxPrice/100;

            maxPrice = maxPrice.toFixed(0).replace(/./g, function(c,i,a){
                return i && c !== "." && ((a.length - i) % 3===0) ? ' '+c : c;
            })

            var monthes = new Array("ЯНВАРЬ", "ФЕВРАЛЬ", "МАРТ", "АПРЕЛЬ", "МАЙ", "ИЮНЬ", "ИЮЛЬ", "АВГУСТ", "СЕНТЯБРЬ", "ОКТЯБРЬ", "НОЯБРЬ", "ДЕКАБРЬ");


            var htmlGraph = "";
            var elem = document.getElementsByClassName("biletix_widget_container__graph")[0];
            var currency = elem.hasAttribute("data-currency") && currencies.hasOwnProperty(elem.getAttribute("data-currency")) ? 
                currencies[elem.getAttribute("data-currency")] : 
                    (currencies.hasOwnProperty(data["currency"]) ? currencies[data["currency"]] : null);

            htmlGraph += "<div class='prices'><span class='zero' style='bottom: 200px;'>"+maxPrice+
                " " + (currency ? currency["currencySymbol"] : "<b>руб</b>") 
                + "</span><span class='zero'>0 " + 
                (currency ? currency["currencySymbol"] : "<b>руб</b>") 
                + "</span></div>";
            htmlGraph += "<div class='monthes'>";

            //var height = data['bar_chart'][j]['price']/percent;
            var wlBasePath = elem.getAttribute("data-wl-base");

            for (var j in data['bar_chart']){
                var height = Math.floor(parseInt(data['bar_chart'][j]['price'])/percent);

                var price = data['bar_chart'][j]['price'].toFixed(0).replace(/./g, function(c,i,a){
                    return i && c !== "." && ((a.length - i) % 3===0) ? ' '+c : c;
                })

                deep_link = data['bar_chart'][j]['deep_link'];
                if (wlBasePath) {
                    deep_link = wlBasePath + 
                        "#/booking?akAndLines=" + btoa(encodeURIComponent(JSON.stringify(data['bar_chart'][j]["ak_and_airline_list"]))) + 
                        "&price=" + data['bar_chart'][j]['price'] + 
                        "&from=" + encodeURI(elem.getAttribute("data-from")) +
                        "&to=" + encodeURI(elem.getAttribute("data-to")) +
                        "&dep_date=" + data['bar_chart'][j]["dep_date"] +
                        "&ret_date=" + data['bar_chart'][j]["ret_date"] +
                        "&oneway=false" +
                        "&adults=1&children=0&infants=0&selected_class=E" +
                        (elem.hasAttribute("data-alt-domain") ? "&altDomain=" + elem.getAttribute("data-alt-domain") : "") +
                        "&only_direct=N";
                }

                htmlGraph +="<a href='" +
                deep_link +
                "' target='_blank'>";
                htmlGraph +="<div class='month m"+j+"' style='height:"+height*2+"px'><div class='tip'>"+price+" "+
                (currency ? currency["currencySymbol"] : "<span>руб</span>") 
                +"</div></div>";
                htmlGraph +="</a>";
                htmlGraph +="<div class='name n"+j+"'>"+monthes[(new Date(data['bar_chart'][j]['date_point'])).getMonth()];
                if ((j == 0) || (new Date(data['bar_chart'][j-1]['date_point']).getFullYear() != new Date(data['bar_chart'][j]['date_point']).getFullYear())) {
                    htmlGraph +="<br />"+new Date(data['bar_chart'][j]['date_point']).getFullYear();
                }
                htmlGraph +="</div>";
            }
            htmlGraph += "</div>";

            elem.innerHTML = "<div id='prices-dynamic'>"+htmlGraph+"</div>";

        }

    };

    setTimeout(__biletix_graph__.showGraph, 100);
})();
